import React, { useState } from "react";
import logo from "../asico.png";
import btmImage from "../asc-btm-image.png";
import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import axios from "axios";
import { Button } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import FileDownload from "@mui/icons-material/FileDownload";
import dayjs from "dayjs";
dayjs.locale("th");

export async function graph_xbar(
  idQuestion,
  partName,
  partNo,
  char,
  min,
  max,
  spec,
  torelance1,
  torelance2,
  image,
  lcl,
  ucl,
  cl,
  lineChart,
  dataAll
) {
  // console.log("DATA ALL", dataAll);
  let createdAtArray = [];

  if (dataAll) {
    dataAll.forEach((item) => {
      if (
        item.data.actual > item.data.ucl ||
        item.data.actual < item.data.lcl
      ) {
        console.log(item.createAt);
        createdAtArray.push(item.createAt);
      }
    });
  }

  console.log(createdAtArray);
  const workbook = new ExcelJS.Workbook({ useStyle: true });
  const worksheet = workbook.addWorksheet("sheet", {
    pageSetup: {
      paperSize: 9,
      orientation: "portrait",
      scale: 90,
      fitToPage: 1,
      horizontalCentered: true,
      margins: {
        left: 0.0,
        right: 0.0,
        top: 0.4,
        bottom: 0.0,
        header: 0.0,
        footer: 0.0,
      },
    },
  });

  ////ADJUST comlumn "1" to minimize
  worksheet.getColumn(1).width = 0;
  // worksheet.getColumn(3).width = 15;

  ////////////

  let font = { name: "CordiaUPC", size: 16 };

  if (logo) {
    const imageBuffer = await axios.get(logo, {
      responseType: "arraybuffer",
    });
    const image_logo = workbook.addImage({
      buffer: imageBuffer.data,
      extension: "png",
    });
    worksheet.addImage(image_logo, {
      tl: { col: 2, row: 1.5 },
      br: { col: 4, row: 4 },
    });
    console.log(image);
  }

  if (btmImage) {
    const imageBuffer = await axios.get(btmImage, {
      responseType: "arraybuffer",
    });
    const btm_image = workbook.addImage({
      buffer: imageBuffer.data,
      extension: "png",
    });
    worksheet.addImage(btm_image, {
      tl: { col: 12, row: 37 },
      br: { col: 19, row: 52.7 },
    });
    console.log(image);
  }

  if (image) {
    const imagePartBuffer = await axios.get(image, {
      responseType: "arraybuffer",
    });
    const image_part = workbook.addImage({
      buffer: imagePartBuffer.data,
      extension: "png",
    });

    worksheet.addImage(image_part, {
      tl: { col: 10, row: 3.5 },
      br: { col: 18, row: 17 },
    });
  }

  if (lineChart) {
    try {
      const line = await axios.get(lineChart, {
        responseType: "arraybuffer",
      });

      const lineChart_toPng = workbook.addImage({
        buffer: line.data,
        extension: "png",
      });
      worksheet.addImage(lineChart_toPng, {
        tl: { col: 2.2, row: 19 },
        br: { col: 17.8, row: 36 },
      });
    } catch (e) {
      throw new Error(`${e}`);
    }
  }

  /////////CONTENT IN LOGO ///////////////
  worksheet.getCell("C6").value = "ID Question :";
  worksheet.getCell("C7").value = "Part Name:";
  worksheet.getCell("C8").value = "Part No.:";
  worksheet.getCell("C9").value = "Characteristic:";
  worksheet.getCell("C10").value = "Specification:";
  worksheet.getCell("C11").value = "Spec-Count:";
  worksheet.getCell("C12").value = "Torelance:";
  worksheet.getCell("C13").value = "Variable-Control:";

  worksheet.getCell("E6").value = idQuestion;
  worksheet.getCell("E7").value = partName;
  worksheet.getCell("E8").value = partNo;
  worksheet.getCell("E9").value = char;
  worksheet.getCell("E10").value = `(min) ${min} (max) ${max}`;
  worksheet.getCell("E11").value = spec;
  worksheet.getCell("E12").value = `± ${torelance1}`;
  worksheet.getCell("F12").value = `± ${torelance2}`;
  worksheet.getCell("E13").value = `(LCL): ${lcl} | (CL):${cl} | (UCL):${ucl}`;

  worksheet.getCell("E11").style = {
    alignment: {
      horizontal: "left",
    },
  };

  worksheet.getCell("A53").border = {
    right: { style: "thin" },
  };

  worksheet.mergeCells("B1:S1");
  const valueHeader = worksheet.getCell("B1");
  valueHeader.value = "X-BAR";
  valueHeader.style = {
    alignment: {
      vertical: "middle",
      horizontal: "center",
    },
    font: {
      name: "Cordia UPC",
      bold: true,
      size: 18,
    },
    fill: {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFFFF803" },
    },
  };
  for (let col = 3; col <= 16; col++) {
    if (col == 16) {
      const cell = worksheet.getCell(1, 16);
      cell.border = {
        top: { style: "thin" },
        right: { style: "thin" },
      };
    } else {
      const cell = worksheet.getCell(1, col);
      cell.border = {
        top: { style: "thin" },
      };
      // }
    }
  }

  worksheet.getCell("S2").border = {
    right: { style: "thin" },
  };

  ///Drawing Sketch
  worksheet.mergeCells("J2:S2");
  let cols = ["K2", "L2", "M2", "N2", "O2", "P2", "Q2", "R2", "S2"];
  ///Drawing Sketch
  cols.forEach((col) => {
    worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
        top: { style: "thin" },
        right: { style: "thin" },
        // left: { style: "thin" },
      },
    };
  });

  worksheet.getCell("S18").style = {
    border: {
      bottom: { style: "thin" },
      right: { style: "thin" },
    },
  };

  let cols1 = [
    // "B18",
    "C18",
    "D18",
    "E18",
    // "F18",
    // "G18",
    // "H18",
    // "I18",
    "J18",
    "K18",
    "L18",
    "M18",
    "N18",
    "O18",
    "P18",
    "Q18",
    "R18",
    // "S18",
  ];
  cols1.forEach((col) => {
    const celDirectly = (worksheet.getCell(`${col}`).style = {
      border: {
        bottom: { style: "thin" },
      },
    });
  });

  let cols2 = ["C2", "D2", "E2", "F2", "G2", "H2", "I2"];
  cols2.forEach((col) => {
    const celDirectly = (worksheet.getCell(`${col}`).style = {
      border: {
        top: { style: "thin" },
      },
    });
  });

  const startCell = worksheet.getCell("J2");
  startCell.value = "DRAWING / SKETCH";
  startCell.style = {
    border: {
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
      top: { style: "thin" },
    },
    alignment: {
      vertical: "middle",
      horizontal: "center",
    },
    font: {
      size: 18,
      name: "CordiaUPC",
    },
  };
  const startRow = 38;
  const endRow = 48;
  const startColumn = "B";
  const endColumn = "J";

  const headers = [
    "#จุดที่",
    "Date\nวันที่",
    "Take Action\nการแก้ไข",
    "In-Charge\nผู้รับผิดชอบ", // index 3 to be skipped
    "Complete date\nวันที่เสร็จ",
    "Follow by\nติดตามการแก้ไข",
    "Judgement\nผลการแก้ไข",
    "Remark\nหมายเหตุ",
  ];

  // Define the starting column index for 'B' (ASCII 66)
  let columnIndex = 66;

  for (let i = 0; i < headers.length; i++) {
    // Skip index 3 (column D)
    if (i === 3) {
      columnIndex++;
    }

    // Determine the column letter based on ASCII code
    const cellAddress = `${String.fromCharCode(columnIndex)}${startRow}`;
    const cell = worksheet.getCell(cellAddress);

    // Set the header value
    cell.value = headers[i];

    // Apply alignment, font, and borders
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
      wrapText: true,
    };
    cell.font = { bold: true };
    cell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };

    columnIndex++;
  }

  // Merge cells and apply borders after merging
  for (let i = 38; i <= 48; i++) {
    worksheet.mergeCells(`D${i}:E${i}`);

    // Apply borders to the merged cell range
    const mergedCell = worksheet.getCell(`D${i}`);
    mergedCell.border = {
      top: { style: "thin" },
      left: { style: "thin" },
      bottom: { style: "thin" },
      right: { style: "thin" },
    };
  }
  for (let i = 0; i < createdAtArray.length; i++) {
    let row = 39 + i;

    worksheet.getCell(`C${row}`).value = dayjs(createdAtArray[i]).format(
      "DD-MM-YYYY"
    );
  }

  // Apply borders to all other cells in the range from startRow to endRow
  for (let row = startRow + 1; row <= endRow; row++) {
    for (let col = 2; col <= 10; col++) {
      const cell = worksheet.getCell(`${String.fromCharCode(64 + col)}${row}`);
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    }
  }

  for (let i = 39; i <= 48; i++) {
    const cell = worksheet.getCell(`B${i}`);
    cell.value = i - 38;
    cell.alignment = {
      vertical: "middle",
      horizontal: "center",
    };
  }

  ///Determine  Row height
  for (let i = 3; i <= 13; i++) {
    worksheet.getRow(i).height = 26;
  }
  for (let i = 39; i <= 49; i++) {
    worksheet.getRow(i).height = 20;
  }

  /// Draw Outer Line
  const borderStyleBottom = {
    bottom: { style: "thin" },
  };

  const borderStyleRight = {
    right: { style: "thin", color: { argb: "000000" } },
  };

  const borderStyleLeft = {
    left: { style: "thin", color: { argb: "000000" } },
  };
  const borderStyleTop = {
    top: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleBottomandRight = {
    bottom: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandBottom = {
    bottom: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandTop = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftandRight = {
    right: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftRightTop = {
    top: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  const borderStyleLeftRightBottom = {
    bottom: { style: "thin", color: { argb: "000000" } },
    left: { style: "thin", color: { argb: "000000" } },
    right: { style: "thin", color: { argb: "000000" } }, // Specify the top border
  };

  for (let col = 2; col <= 18; col++) {
    const cell = worksheet.getCell(53, col);
    cell.border = {
      bottom: { style: "thin" },
      // right: { style: "thin" },
      // left: { style: "thin" },
    };
  }

  worksheet.getCell("G18").border = borderStyleBottom;
  worksheet.getCell("F18").border = borderStyleBottom;
  worksheet.getCell("H18").border = borderStyleBottom;

  for (let i = 3; i <= 17; i++) {
    const cell = worksheet.getCell(`S${i}`);
    cell.border = borderStyleRight;
  }

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`S${i}`);
    cell.border = borderStyleRight;
  }

  //52
  for (let i = 2; i <= 37; i++) {
    const cell = worksheet.getCell(`B${i}`);
    if (i == 18) {
      cell.border = borderStyleLeftandBottom;
    } else {
      cell.border = borderStyleLeft;
    }
  }
  for (let i = 49; i <= 52; i++) {
    const cell = worksheet.getCell(`B${i}`);
    cell.border = borderStyleLeft;
  }

  worksheet.getCell("B1").border = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
  };

  for (let i = 19; i <= 52; i++) {
    const cell = worksheet.getCell(`D${i}`);
    if (i >= 23 && i % 3 == 0) {
      continue;
    } else {
      // cell.border = borderStyleLeft;
    }
  }
  worksheet.getCell("S53").border = {
    right: { style: "thin" },
    bottom: { style: "thin" },
  };

  for (let i = 3; i <= 18; i++) {
    const cell = worksheet.getCell(`I${i}`);
    if (i == 18) {
      cell.style = {
        border: {
          right: { style: "thin" },
          bottom: { style: "thin" },
        },
      };
    } else {
      cell.style = {
        border: {
          right: { style: "thin" },
        },
      };
    }
    // }
  }
  function getColumnLetter(index) {
    let letter = "";
    let tempIndex = index - 1;
    while (tempIndex >= 0) {
      letter = String.fromCharCode((tempIndex % 26) + 65) + letter;
      tempIndex = Math.floor(tempIndex / 26) - 1;
    }
    return letter;
  }

  ///Formula Equataion

  await workbook.xlsx.writeBuffer().then((res) => {
    const fileType =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const fileExtension = ".xlsx";
    const blob = new Blob([res], { type: fileType });
    saveAs(blob, `${"Xbar" + dayjs().format("DD/MM/YYYY")}` + fileExtension);
    // saveAs(
    //   blob,
    //   `${dataExport.partName + "_CPL_" + dayjs().format("DD/MM/YYYY")}` +
    //     fileExtension
    // );
  });
}
const ExportGraphXbar = ({ data, isReady }) => {
  const [disabled, setDisabled] = useState(true);

  return (
    <div className="App">
      <Button
        // style={{ padding: "10px", margin: "5px" }}
        disabled={disabled}
        onClick={() => graph_xbar(data)}
        variant="outlined"
        endIcon={<Icon isReady={isReady} setDisabled={setDisabled} />}
      >
        download
      </Button>
    </div>
  );
};

export default ExportGraphXbar;

const Icon = ({ isReady, setDisabled }) => {
  if (isReady === undefined) {
    setDisabled(false);
    return <FileDownload />;
  } else {
    if (isReady) {
      setTimeout(() => {});
      setDisabled(false);
      return <FileDownload />;
    } else {
      setDisabled(true);
      return <CircularProgress size={20} />;
    }
  }
};
